import React, {useEffect} from 'react';
import ImageSelector from '@di-shared/features/common/ImageSelector';
import {ROUTE_PATHS} from '@di-shared/routes';
import {WebviewUtils} from '@shared/webviewUtils';

export interface CapitalEventBannerType1Props {
  vin: string;

  onClick(): void;
}

/**
 * [2025-09-03:cy.seo] FIXME: 이벤트 후 제거  EVENT2
 *
 * @constructor
 */
function CapitalEventBannerType1({vin, onClick}: CapitalEventBannerType1Props): JSX.Element {
  const brand = import.meta.env.VITE_BRAND as 'KIA' | 'HYUNDAI' | 'GENESIS';
  useEffect(() => {
    setTimeout(() => {
      document.querySelector('#bannerType1')?.classList.add('is_show');
    }, 100);
  }, []);

  return (
    <>
      <div className="driving_banner type_event">
        <a
          role="button"
          className="driving_banner_box"
          onClick={() => {
            onClick();
            WebviewUtils.openNewWebView({
              url: window.location.origin + ROUTE_PATHS.CAPITAL_EVENT_1.getFullPath(vin),
              isModal: true,
              isNavigationBar: false,
              isToolBar: false,
            });
          }}
        >
          <span className="driving_banner_txtbox type_reverse">
            <strong className="driving_banner_title body_large_b">
              모빌리티소비 정보 확인하고 <br />
              백화점 상품권을 잡아라!
            </strong>
            <span className="driving_banner_desc body_small_r">내 차 금융관리 경품 이벤트</span>
          </span>
          <span className="driving_banner_imgbox ">
            <ImageSelector
              className="driving_banner_img"
              alt=""
              kiaLightSrc={() => import('@di-shared/assets/img/event/img_event_banner.png')}
              kiaDarkSrc={() => import('@di-shared/assets/img/event/img_event_banner.png')}
              hyundaiLightSrc={() => import('@di-shared/assets/img/event/hyundai/img_event_hyundai_img_event_banner_light.png')}
              hyundaiDarkSrc={() => import('@di-shared/assets/img/event/hyundai/img_event_hyundai_img_event_banner.png')}
              genesisLightSrc={() => import('@di-shared/assets/img/event/genesis/img_event_genesis_img_event_banner_light.png')}
              genesisDarkSrc={() => import('@di-shared/assets/img/event/genesis/img_event_genesis_img_event_banner.png')}
            />
          </span>
        </a>
      </div>
      <div
        id="bannerType1"
        className="banner_show_box"
      ></div>
    </>
  );
}

export default CapitalEventBannerType1;
